export enum CheckinReasonType {
  CHECKIN = 'CHECKIN',
  EVENT = 'EVENT',
  FLEXTIME = 'FLEXTIME',
}
